export enum JobExtendedStatus {
    None = 0,
    Disconnected = 6,
    Queued = 7
}
